// Peptidelle. No dependencies. Every feature falls back to plain forms and links.
(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const root = window.Shopify?.routes?.root || '/';
  const bag = () => $('#bag');

  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: cents % 100 ? 2 : 0,
    }).format(cents / 100);

  const showBag = () => {
    const dialog = bag();
    if (dialog && !dialog.open) dialog.showModal();
  };

  const renderBag = (html) => {
    if (!html) return;
    const next = $('[data-bag-body]', new DOMParser().parseFromString(html, 'text/html'));
    if (!next) return;
    $('[data-bag-body]').replaceWith(next);
    $$('[data-bag-count]').forEach((el) => { el.textContent = next.dataset.count; });
  };

  const post = (path, options) =>
    fetch(root + path, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', ...options.headers },
      body: options.body,
    });

  async function addToBag(form, button) {
    const error = $('[data-form-error]', form);
    if (error) error.textContent = '';
    const body = new FormData(form);
    body.append('sections', 'bag');
    body.append('sections_url', location.pathname);
    button?.setAttribute('disabled', '');
    try {
      const response = await post('cart/add.js', { body });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);
      renderBag(data.sections?.bag);
      showBag();
    } catch (failure) {
      if (error) error.textContent = failure.message || 'Something went wrong. Please try again.';
    } finally {
      button?.removeAttribute('disabled');
    }
  }

  async function changeLine(line, quantity) {
    const response = await post('cart/change.js', {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity, sections: ['bag'], sections_url: location.pathname }),
    });
    if (response.ok) renderBag((await response.json()).sections?.bag);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('[data-add-form]') || !bag()) return;
    event.preventDefault();
    addToBag(form, event.submitter);
  });

  document.addEventListener('click', (event) => {
    const dialog = bag();
    const target = event.target;
    if (target.closest?.('[data-bag-open]') && dialog) {
      event.preventDefault();
      showBag();
    } else if (target.closest?.('[data-bag-close]') || target === dialog) {
      dialog.close();
    }
    const quantity = target.closest?.('[data-quantity]');
    if (quantity && dialog) {
      event.preventDefault();
      changeLine(Number(quantity.dataset.line), Number(quantity.dataset.quantity));
    }
    const menu = $('#menu');
    if (target.closest?.('[data-menu-open]') && menu) {
      event.preventDefault();
      menu.showModal();
    } else if (menu?.open && (target === menu || target.closest?.('[data-menu-close], a'))) {
      menu.close();
    }
  });

  $$('[data-pdp]').forEach((pdp) => {
    const picker = $('[data-variant-picker]', pdp);
    const variants = picker ? JSON.parse($('[data-variants]', picker).textContent) : [];
    const input = $('[data-quantity-input]', pdp);
    const note = $('[data-ship-note]', pdp);
    const threshold = Number(note?.dataset.threshold || 0);
    const priceLabel = $('[data-price]', pdp);
    let unit = Number(priceLabel?.dataset.cents) || Math.round(Number(priceLabel?.textContent.replace(/[^0-9.]/g, '')) * 100);

    const refresh = () => {
      const quantity = Math.max(1, Number(input?.value) || 1);
      $$('[data-price]').forEach((el) => { el.textContent = money(unit * quantity); });
      if (!note || !threshold) return;
      const total = unit * quantity;
      if (total >= threshold) note.textContent = 'This order ships free in the US';
      else if (total + unit >= threshold) note.textContent = 'Add one more and US shipping is on us';
      else note.textContent = `Free US shipping from ${money(threshold)}`;
    };

    $$('[data-step]', pdp).forEach((button) => button.addEventListener('click', () => {
      input.value = Math.max(1, (Number(input.value) || 1) + Number(button.dataset.step));
      refresh();
    }));
    input?.addEventListener('change', refresh);

    picker?.addEventListener('change', () => {
      const chosen = $$('fieldset', picker).map((set) => $('input:checked', set).value);
      const variant = variants.find((item) => item.options.every((value, index) => value === chosen[index]));
      const button = $('[data-add-button]', pdp);
      button.disabled = !variant?.available;
      button.textContent = variant?.available ? 'Add to bag' : 'Sold out';
      if (!variant) return;
      $('[data-variant-id]', pdp).value = variant.id;
      history.replaceState(null, '', `${location.pathname}?variant=${variant.id}`);
      unit = variant.price;
      refresh();
    });

    const gallery = $('[data-gallery]', pdp);
    const thumbs = $$('[data-thumb]', pdp);
    const setThumb = (index) => thumbs.forEach((thumb, i) => {
      if (i === index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
      gallery.scrollTo({ left: gallery.clientWidth * index, behavior: 'smooth' });
      setThumb(index);
    }));
    gallery?.addEventListener('scrollend', () => setThumb(Math.round(gallery.scrollLeft / gallery.clientWidth)));

    const sticky = $('[data-sticky-buy]');
    const anchor = $('[data-buy-anchor]', pdp);
    if (sticky && anchor) {
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(anchor);
    }
  });
})();
